import { InsertArtText } from './insert-art-text.js';


export function ArtText (pEditor)
{
  this.inserter = new InsertArtText(pEditor, this);
  
  this.currentArtTextPicture = null;
  
  
  this.queryArtTextEnabled = (pButton, command) =>
  {
    return true;
  };


  this.queryInsertArtTextState = (pButton, command) =>
  {
    var ret = false;

    this.currentArtTextPicture = pEditor.image.getCurrentImage();

    if (this.currentArtTextPicture)
    {
      ret = isArtTextImage(this.currentArtTextPicture) ? true : false;
    }

    return ret;
  };


  function getArtTextImageId (currentImage)
  {
    return currentImage.src.match(/\/arttext\/(\S+\.png)\??(.*)/i);
  }


  function isArtTextImage (currentImage)
  {
    return (getArtTextImageId(currentImage) ? true : false);
  }

  
  this.getArtTextImageId = getArtTextImageId;
  this.isArtTextImage = isArtTextImage;
}